import { defineMessages } from 'react-intl';

export default defineMessages({
    optionalNIPlaceholder: {
        id: 'gateway.views.new-quote.optional',
        defaultMessage: 'Optional'
    }
});
